// src/components/Navbar.jsx
import React, { useState } from "react";
import { Link } from "react-router-dom";
import "./Navbar.css";
import defaultLogo from "../assets/panelzero-icon.png";

function Navbar({
  logoSrc = defaultLogo,
  logoAlt = "PanelZero logo",
}) {
  const [isOpen, setIsOpen] = useState(false);
  const toggleSidebar = () => setIsOpen((o) => !o);

  return (
    <div>
      <nav className="navbar">
        <div className="navbar-left">
          <div className="hamburger" onClick={toggleSidebar} aria-label="Open menu">
            &#9776;
          </div>

          <Link to="/" className="logo-and-title" aria-label="PanelZero home">
            <img src={logoSrc} alt={logoAlt} />
            <h1>PanelZero</h1>
          </Link>
        </div>

        <div className="nav-links">
          <Link to="/">Home</Link>
          <Link to="/about">About</Link>
          <Link to="/#integrations">Integrations</Link>
          <Link to="/#faq">FAQ</Link>
        </div>

        <div className="navbar-right">
          <Link to="/contact" className="navbar-cta">
            <span className="navbar-cta-inner">
              <span className="navbar-cta-label">Request demo</span>
              <span className="navbar-cta-icon" aria-hidden="true">
                <svg viewBox="0 0 24 24" width="16" height="16">
                  <path
                    d="M5 12h12M13 6l6 6-6 6"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                </svg>
              </span>
            </span>
          </Link>
        </div>
      </nav>

      {/* Mobile Sidebar */}
      <div className={`sidebar ${isOpen ? "open" : ""}`}>
        <div className="close-btn" onClick={toggleSidebar} aria-label="Close menu">
          &times;
        </div>
        <Link to="/" onClick={toggleSidebar}>Home</Link>
        <Link to="/about" onClick={toggleSidebar}>About</Link>
        <Link to="/#integrations" onClick={toggleSidebar}>Integrations</Link>
        <Link to="/#faq" onClick={toggleSidebar}>FAQ</Link>
        <Link to="/contact" onClick={toggleSidebar}>Request demo</Link>
      </div>
    </div>
  );
}

export default Navbar;
